var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullScreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.863,
    height: 19.863,
    viewBox: "0 0 19.863 19.863",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_90_",
    "data-name": "svgexport-6 (90)",
    transform: "translate(-9.046 -9.046)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M21.862,28.644a1.269,1.269,0,0,1,1.265-1.265h2.986a1.269,1.269,0,0,0,1.265-1.265V23.128a1.265,1.265,0,0,1,2.53,0v2.986a3.807,3.807,0,0,1-3.8,3.8H23.127A1.269,1.269,0,0,1,21.862,28.644Zm8.046-11.816a1.265,1.265,0,1,1-2.53,0V13.841a1.269,1.269,0,0,0-1.265-1.265H23.127a1.265,1.265,0,1,1,0-2.53h2.986a3.807,3.807,0,0,1,3.8,3.8ZM13.841,27.378h2.986a1.265,1.265,0,1,1,0,2.53H13.841a3.807,3.807,0,0,1-3.8-3.8V23.128a1.265,1.265,0,0,1,2.53,0v2.986A1.269,1.269,0,0,0,13.841,27.378Zm2.986-14.8H13.841a1.269,1.269,0,0,0-1.265,1.265v2.986a1.265,1.265,0,1,1-2.53,0V13.841a3.807,3.807,0,0,1,3.8-3.8h2.986a1.265,1.265,0,1,1,0,2.53Z",
    transform: "translate(-1 -1)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreen);
export default __webpack_public_path__ + "static/media/full-screen.b1788d10f9aaca41514d70a6d1aaf910.svg";
export { ForwardRef as ReactComponent };